import { render, staticRenderFns } from "./PosDebtBalanceList.vue?vue&type=template&id=20418079&scoped=true&"
import script from "./PosDebtBalanceList.vue?vue&type=script&lang=js&"
export * from "./PosDebtBalanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20418079",
  null
  
)

export default component.exports